// src/slices/article/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// ================= GET ALL ARTICLES =================
export const getArticles = createAsyncThunk("article/getArticles", async ({ CategoryId, type, search, page = 1, limit = 10 } = {}, { rejectWithValue }) => {
  try {
    const params = { page, limit };

    if (CategoryId) params.CategoryId = CategoryId;
    if (type) params.type = type;
    if (search) params.search = search;

    const response = await axios.get(`${API_URL}/article/all`, { params });


    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});
// ================= GET ONE ARTICLE =================
export const getOneArticle = createAsyncThunk("article/getOneArticle", async (identifier, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/article/one`, { params: { identifier } });
    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});
